import { Ballad } from '@digimap/types'

export const isRouted = (ballad: Ballad): boolean => Boolean(ballad.track)

// @todo store ballad by ids
export function getBalladById(
  id: string,
  ballads: Ballad[]
): Ballad | undefined {
  return ballads.find((b) => b._id === id)
}

export function getBalladByIdOrSlug(
  idOrSlug: string,
  ballads: Ballad[]
): Ballad | undefined {
  return ballads.find((b) => b._id === idOrSlug || b.slug === idOrSlug)
}
